import { HTTPService } from './HttpService';
import { Comment } from '../types';

export class CommentService {
  private httpService: HTTPService;

  constructor(httpService: HTTPService) {
    this.httpService = httpService;
  }

  async getPhotoComments(photoId: number): Promise<Comment[]> {
    const response = await this.httpService.get(`/photos/${photoId}/comments`);
    return response.data;
  }

  async createComment(photoId: number, text: string): Promise<Comment> {
    const response = await this.httpService.post(`/photos/${photoId}/comments`, { text });
    return response.data;
  }

  async updateComment(commentId: number, text: string): Promise<Comment> {
    const response = await this.httpService.patch(`/photos/comments/${commentId}`, { text });
    return response.data;
  }

  async deleteComment(commentId: number): Promise<void> {
    await this.httpService.delete(`/photos/comments/${commentId}`);
  }
}
